import { ISmartProps } from './types';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { StyleObject } from 'styletron-react';
import { dialogBackdropStyles, dialogCloseIconStyle, dialogDialogStyles, dialogRootStyles } from './styles';
import React from 'react';
import { CloseIconComponent } from '../../Utilities/utils/Theming';
import * as meta from '../../meta-data.json';

export const overrides = (props: ISmartProps) => {
	const HTMLAttrs = getHTMLAttributes(props);
	return {
		Root: {
			style: () => {
				return {
					...dialogRootStyles(props),
				};
			},
			props: {
				id: props.id,
				className: props.className,
				'data-epo': `epo-dialog-${meta.version}`,
				part: `epo-dialog-${meta.version}`,
			},
		},
		Dialog: {
			style: () => {
				return dialogDialogStyles(props) as StyleObject;
			},
			props: {
				...getBaseCustomProps(props),
				...HTMLAttrs.dataProps,
				...HTMLAttrs.ariaProps,
			},
		},
		DialogContainer: {
			style: {
				...dialogBackdropStyles,
			},
		},
		Close: {
			props: {},
			component: ({ onClick }: any) => {
				return !props.hideHeader ? (
					<CloseIconComponent size="large" onClick={onClick} style={dialogCloseIconStyle(props.size)} />
				) : null;
			},
		},
	};
};
